<!--
******************************
 * @author Jesus R. Nava Cruz
 * @date May 26, 2023
 * @version 1.0
******************************
-->
<template>
  <div>
    <v-row>
      <v-col>
        <ValidationProvider
          v-slot="{ errors, invalid, touched }"
          name="Nombre"
          rules="required|max:50|min:2"
        >
          <v-text-field
            :counter="50"
            maxLenght="40"
            v-model.trim="model.name"
            label="Nombre *"
            required
            autocomplete="off"
            :error-messages="errors"
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col>
        <ValidationProvider
          v-slot="{ errors, invalid, touched }"
          name="Tipo de espacio físico"
          rules="required"
        >
          <v-autocomplete
            v-model="type"
            label="Tipo de espacio físico *"
            :items="types"
            required
            autocomplete="off"
            :error-messages="errors"
            :search-input.sync="search"
            :loading="isLoading"
            return-object
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-autocomplete>
        </ValidationProvider>
      </v-col>
      <v-col>
        <ValidationProvider
          v-slot="{ errors, invalid, touched }"
          name="Sucursal"
          rules="required"
        >
          <v-autocomplete
            v-model="model.branchOffice"
            label="Sucursal *"
            :items="branchOffices"
            required
            autocomplete="off"
            :error-messages="errors"
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-autocomplete>
        </ValidationProvider>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { ValidationProvider } from "vee-validate";
export default {
  name: "PhysicalSpacesForm",
  components: {
    ValidationProvider,
  },
  props: {
    model: Object,
  },
  data: () => ({
    isLoading: false,
    types: [],
    branchOffices: [],
    type: null,
    search: null,
  }),
  watch: {
    search(newVal, val) { 

      if (this.isLoading) return
      this.isLoading = true;

      fetch(`https://dummyjson.com/products/search?q=${newVal}`)
        .then((res) => res.json())
        .then((res) => {
          console.log(res);
          this.types = res.products.map((item) => {
            return {
              value: item.id,
              text: item.title
            }
          })
        })
        .finally(() => this.isLoading = false)

    }
  },

};
</script>